export default __webpack_public_path__ + "static/Refinn_logo-3c37e3c9f7f838c2ac37f2f334030387.png";